import React from 'react';
import { FaChartBar } from "react-icons/fa";
import Card from 'react-bootstrap/Card';
import { Doughnut, Bar, HorizontalBar } from "react-chartjs-2";
import './Graph.css';

const Graph = (props) => {
    const chart = props.type === 'horizontalBar'
        ? <HorizontalBar data={props.data} options={props.options} />
        : props.type === 'bar'
            ? <Bar data={props.data} options={props.options} />
            : <Doughnut data={props.data} options={props.options} />;

    if (props.embedded) {
        return <div className="graph-embedded">{chart}</div>;
    }

    return (
        <Card className={['graph-card', props.className].filter(Boolean).join(' ')}>
        <Card.Header>
            <div className="graph-header">
                <span className="graph-title"><FaChartBar /> {props.title}</span>
                {props.subtitle ? <span className="graph-subtitle text-secondary">{props.subtitle}</span> : null}
            </div>
        </Card.Header>
        <Card.Body>
            {chart}
        </Card.Body>
        </Card>
    )
}
 
export default Graph;
